import React from "react"
import "../styles/mystery.scss"

interface LightSpec {
  left: string
  top: string
  anim: "a" | "b" | "c"
  dur: number
  delay: number
  warm: boolean
}

const lightSpecs: LightSpec[] = [
  { left: "8%", top: "82%", anim: "a", dur: 16, delay: 0, warm: false },
  { left: "16%", top: "65%", anim: "b", dur: 22, delay: 4, warm: false },
  { left: "23%", top: "88%", anim: "a", dur: 19, delay: 8, warm: true },
  { left: "31%", top: "72%", anim: "c", dur: 24, delay: 2, warm: false },
  { left: "39%", top: "55%", anim: "b", dur: 18, delay: 11, warm: false },
  { left: "46%", top: "85%", anim: "a", dur: 21, delay: 6, warm: false },
  { left: "54%", top: "48%", anim: "c", dur: 26, delay: 14, warm: true },
  { left: "62%", top: "78%", anim: "b", dur: 17, delay: 9, warm: false },
  { left: "69%", top: "60%", anim: "a", dur: 23, delay: 3, warm: false },
  { left: "76%", top: "84%", anim: "c", dur: 20, delay: 12, warm: false },
  { left: "83%", top: "70%", anim: "b", dur: 25, delay: 5, warm: true },
  { left: "90%", top: "88%", anim: "a", dur: 18, delay: 15, warm: false },
  { left: "12%", top: "40%", anim: "c", dur: 28, delay: 7, warm: false },
  { left: "44%", top: "30%", anim: "b", dur: 27, delay: 13, warm: false },
  { left: "78%", top: "35%", anim: "a", dur: 30, delay: 1, warm: true },
]

const MysteryBackdrop: React.FC = () => {
  return (
    <div className="mystery-backdrop" aria-hidden="true">
      <div className="lights">
        {lightSpecs.map((s, i) => (
          <span
            key={i}
            className={`light light-${s.anim}${s.warm ? " light-warm" : ""}`}
            style={{
              left: s.left,
              top: s.top,
              animationDuration: `${s.dur}s`,
              animationDelay: `${s.delay}s`,
            }}
          />
        ))}
      </div>
    </div>
  )
}

export default React.memo(MysteryBackdrop)
